import { VxAppColor, vxAppColors } from 'presentation/styleguide/vx-colors-style';
import styled from 'styled-components';

type VXRoundedSkeletonStyleType = {
  size: number;

  skeletonColor: 'white' | 'principal' | 'lightest' | 'light';
};

const setColor = (color: string): VxAppColor => {
  if (color === 'lightest') return vxAppColors.brand.tertiary.lightest;
  if (color === 'light') return vxAppColors.brand.primary.lightest;
  if (color === 'principal') return vxAppColors.brand.tertiary.principal;
  return vxAppColors.neutral.white;
};
const setAnimationColor = (color: string): VxAppColor => {
  if (color === 'lightest') return vxAppColors.brand.primary.lightest;
  if (color === 'light') return vxAppColors.brand.tertiary.lightest;
  if (color === 'principal') return vxAppColors.brand.tertiary.light;
  return vxAppColors.neutral.lightest;
};

export const VXRoundedSkeleton = styled.div<VXRoundedSkeletonStyleType>`
  @keyframes shimmer {
    from {
      left: -${(props) => props.size}px;
    }
    to {
      left: 100%;
    }
  }

  border-radius: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  position: relative;
  overflow: hidden;
  background-color: ${(props) => setColor(props.skeletonColor)};
  ::before {
    content: '';
    position: absolute;
    left: -${(props) => props.size}px;
    top: 0;
    height: 100%;
    width: ${(props) => props.size / 3}px;
    background: linear-gradient(
      to right,
      transparent 0%,
      ${(props) => setAnimationColor(props.skeletonColor)} 50%,
      transparent 100%
    );
    animation: shimmer 2s linear infinite;
  }
`;
